import type { QueryKey } from '@tanstack/react-query'

const TENANT_QUERY_PREFIXES = new Set([
  'grading',
  'inbox',
  'materials',
  'questions',
  'quizzes',
  'reply-template',
  'student-quizzes',
  'teaching',
  'threads',
  'ufp',
])

/**
 * Tenant APIs derive X-Tenant-Id outside React Query, so cached data must not
 * survive a workspace boundary under the same login token.
 */
export function isTenantSensitiveQueryKey(queryKey: QueryKey): boolean {
  const prefix = queryKey[0]
  return typeof prefix === 'string' && TENANT_QUERY_PREFIXES.has(prefix)
}
